import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { CommonApiData, initializeFilterData } from "../../EnvConfig/env_config";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { autoCompleteDelay } from "../../config";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FetchAutoCompleteData, FindTranslatedKey, convertToNumber, deleteData } from "../CommonComponents/CustomHooks";
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, handleDownloadExcel, readFile } from "../CommonComponents/ExportData";
import { AutoCompleteBox, FormButton, ImportButton, InputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const PinCodeMaster = ({ menuText }) => {
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [HandleChoose, setHandleChoose] = useState(false)
    const [Status, setStatus] = useState([])
    const [ImportData, setImportData] = useState([])
    const [Name, setName] = useState('');
    const [currentPageNo, setCurrentPageNo] = useState(1);
    let [result, setResult] = useState([]);
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [disableEdit, setDisableEdit] = useState(false)
    const Hide = false;
    const [formData, setFormData] = useState({
        "pinCodeID": '',
        "pinCode": '',
        "cityCode": '',
        "countryCode": '',
        "stateCode": '',
        "active": true
    })

    const handleClear = () => {
        setFormData({
            "pinCodeID": '',
            "pinCode": '',
            "cityCode": '',
            "countryCode": '',
            "stateCode": '',
            "active": true
        });
        filterData.SearchText = ''
        setStatus([])
        setImportData([])
        setHandleChoose(false)
        setName(false)
        getPinCodeMasterData()
       // inputrefs.current['txtCountryCode'].focus();
        BulkClearData(setName)
        setDisableEdit(false)
    };

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Master/InsertUpdatePinCodeMaster', formData)
        await dispatch(setSubLoading(false))
        if (data.status === 'ERROR' || data.status === 'EXPIRED' || data.status === 'UNAUTHORIZED' || data.status === 'SUCCESS') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
        }
    }
    const handleDelete = async (ID) => {
        await dispatch(setSubLoading(true))
        await deleteData('/api/Master/DeletePinCodeMaster', { pinCodeID: ID }, getPinCodeMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const Data = CommonApiData()
    let IData = {
        ...Data,
        "cityID": "",
    }

    const DownloadFormat = async () => {
        await DownloadFileAtURL('PinCodeMaster.xlsx')
    };

    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'PinCodeMasterError')
    }

    const BulkSubmit = async (e) => {
        await dispatch(setSubLoading(true))
        let data = await readFile(e)
        setImportData(data.exceljson)
        setName(data.FileName)
        await dispatch(setSubLoading(false))
        let a = document.querySelectorAll('.bulk-upload');
        if (a.length > 0) {
            a[0].childNodes[2].innerHTML = data.FileName;
        }
    };

    const handleBulk = async () => {
        if (ImportData.length !== 0) {
            if ((Object.keys(ImportData[0])).includes("CityCode", "CountryCode", "StateCode", "PinCode", "Active")) {
                await dispatch(setSubLoading(true))
                let Data = await HandleBulkInsertData('/api/Master/InsertUpdatePinCodeMaster', ImportData, IData, getPinCodeMasterData)
                await setStatus(Data)
                await dispatch(setSubLoading(false))
                await NotificationSound('INFO', `Success : ${Data.SuccessCount} Error : ${Data.ErrorCount}`);
                BulkClearData(setName)

            } else {
                await NotificationSound('ERROR', 'Header Format is not valid !');
                BulkClearData(setName)
            }
        } else {
            await NotificationSound('ERROR', 'Please Choose File With Valid Data.!');
            BulkClearData(setName)
        }
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleEdit = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall('/api/Master/EditPinCodeMaster', { pinCodeID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR'|| editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setDisableEdit(true)
            let record = editData.data
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }

    }

    let PageName = "PinCodeMaster"

    const getPinCodeMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/Master/ShowPinCodeMaster', GetData)
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const handleChange1 = (event, value) => {
        getPinCodeMasterData(value);
    };

    const autoCompleteTimeoutRef = useRef(null);
    const handleAutoCompleteChange = async (event, newValue, field, type) => {
        if (autoCompleteTimeoutRef.current) {
            clearTimeout(autoCompleteTimeoutRef.current);
        }
        if (event?.type === 'change') {
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData('', newValue, type, field);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay)
        }
    };

    useEffect(() => {
        getPinCodeMasterData();
    }, [sortConfig])

    useEffect(() => {
      //  inputrefs.current['txtCountryCode'].focus();
        document.title = 'Pin Code Master'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> {menuText ? menuText : FindTranslatedKey('Pin Code Master')}</h6>
                </div>
                <div className='card-body row'>
                    <div className='col-md-6 col-lg-8'>
                     {/*   {Hide ? <>*/}
                            <div className='row'>
                                {/*<InputBox*/}
                                {/*    divclassname='col-md-4 col-sm-6 mb-2'*/}
                                {/*    label='Pin Code'*/}
                                {/*    placeholder='Pin Code'*/}
                                {/*    required={true}*/}
                                {/*    inputrefs={inputrefs}*/}
                                {/*    id='txtPinCode'*/}
                                {/*    disabled={disableEdit}*/}
                                {/*    value={formData.pinCode}*/}
                                {/*    maxLength='6'*/}
                                {/*    onChange={(e) => {*/}
                                {/*        setFormData({ ...formData, pinCode: convertToNumber(e.target.value) })*/}
                                {/*    }}*/}
                                {/*    onKeyDown={(e) => {*/}
                                {/*        if (e.key === 'Enter') {*/}
                                {/*            inputrefs.current['txtCountryCode'].focus();*/}
                                {/*        }*/}
                                {/*    }}*/}
                                {/*/>*/}

                                <AutoCompleteBox
                                    divclassname='col-md-4 col-sm-6 mb-2'
                                    label='Country'
                                    placeholder='Country'
                                    inputValue={formData.countryCode ? formData.countryCode : ''}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, '', 'GetCountry');
                                            setFormData({ ...formData, countryCode: newInputValue })
                                        }}
                                    maxLength='50'
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    required={true}
                                    inputrefs={inputrefs}
                                    id='txtCountryCode'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtStateCode'].focus() };
                                    }}
                                />

                                <AutoCompleteBox
                                    divclassname='col-md-4 col-sm-6 mb-2'
                                    label='State'
                                    placeholder='State'
                                    inputValue={formData.stateCode ? formData.stateCode : ''}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, formData.countryCode, 'GetState_CountryWise');
                                            setFormData({ ...formData, stateCode: newInputValue })
                                        }}
                                    maxLength='50'
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    required={true}
                                    inputrefs={inputrefs}
                                    id='txtStateCode'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtCityCode'].focus() };
                                    }}
                                />

                                <AutoCompleteBox
                                    divclassname='col-md-4 col-sm-6 mb-2'
                                    label='City'
                                    placeholder='City'
                                    inputValue={formData.cityCode ? formData.cityCode : ''}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, formData.stateCode, 'GetCity_StateWise');
                                            setFormData({ ...formData, cityCode: newInputValue })
                                        }}
                                    maxLength='50'
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    required={true}
                                    inputrefs={inputrefs}
                                id='txtCityCode'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtPinCode'].focus() };
                                    }}
                                />
                                <AutoCompleteBox
                                    divclassname='col-md-4 col-sm-6 mb-2'
                                    label='Pin Code'
                                    placeholder='Pin Code'
                                    inputValue={formData.pinCode ? formData.pinCode : ''}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, formData.cityCode, 'GetPinCode_CityWise');
                                            setFormData({ ...formData, pinCode: newInputValue })
                                        }}
                                    maxLength='6'
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    required={true}
                                    inputrefs={inputrefs}
                                    id='txtPinCode'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtActive'].focus() };
                                    }}
                                />
                                <Switch
                                    label='Active'
                                    inputrefs={inputrefs}
                                    id='txtActive'
                                    checked={formData.active}
                                    onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['btnSave'].focus() };
                                    }}
                                />
                            </div>
                       {/* </> : <></>}*/}
                      
                        <div className='row pb-1'>
                            <FormButton
                                id='btnSave'
                                inputrefs={inputrefs}
                                handleSubmit={handleSubmit}
                              //  save={false}
                                handleExport={async () => {
                                    await dispatch(setSubLoading(true))
                                    await handleDownloadExcel('/api/Master/ShowPinCodeMaster', filterData, 'PinCode Master')
                                    await dispatch(setSubLoading(false))
                                }}
                                importData={true}
                                BulkSubmit={(e) => BulkSubmit(e)}
                                handleBulk={handleBulk}
                                UploadState={HandleChoose}
                                FileName={Name}
                                downloadFormat={DownloadFormat}
                                HandleChoose={() => setHandleChoose(!HandleChoose)}
                                handleClear={handleClear} />

                        </div>
                    </div>
                   {/* {Hide ? <>*/}
                        <div className='d-flex col-md-6 col-lg-4 h-25'>
                            <ImportButton
                                handleBulk={handleBulk}
                                BulkSubmit={(e) => BulkSubmit(e)}
                                downloadFormat={DownloadFormat}
                                ErrorData={ErrorData}
                                Status={Status}
                                HeaderFormat="PayMode, Active"
                                fileName={Name}
                            >
                            </ImportButton>
                        </div>
                 {/*   </> : <></>}*/}
                    <Table handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        PageName={PageName}
                        loading={loading}
                        handleFilter={() => {
                            getPinCodeMasterData()
                            setFilterData({
                                ...filterData,
                            })
                        }}
                        filterData={filterData}
                        tableData={result}
                        setFilterData={setFilterData}
                        currentPageNo={currentPageNo}
                        handleChange1={handleChange1}
                        handleSorting={handleSorting}
                        sortConfig={sortConfig}
                    />
                   
                </div>
            </div>

           
        </>
    )
}

export default PinCodeMaster